import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

export const Route = createFileRoute('/shared/folder/$folderId/')({
  validateSearch: zodValidator(z.object({ token: z.string() })),
});
